/**
 * Green Bubble - decorative pot picker: model and colour layer
 * ---------------------------------------------------------------------------
 * Groups the pot cards in the "Kies je sierpot" (choose your pot) strip per POT
 * MODEL, so only one card per model remains in the row. Below the strip a
 * COLOUR row appears with the available colours of the chosen model.
 *
 * This layer deliberately stays SEPARATE from assets/app.js (that is a webpack
 * build from the agency's src repo and is overwritten by every new build). This
 * file does not touch that bundle: it waits until initOppotConfigurator is done
 * and then only rearranges the existing DOM nodes. Because the cards are MOVED
 * and not copied, all jQuery handlers that PotFinder attached at init keep
 * working.
 *
 * Model and colour come from the metafields custom.pot_model / custom.pot_kleur.
 * As long as those are not filled yet, they are derived from the product title.
 *
 * A plain script without modules or a build step, served by Shopify as-is. Its syntax
 * goes up to ES2019 (optional catch binding; trailing commas in calls from the
 * formatter), so it needs a browser from 2018 or later (Safari 11.1+, Chrome 66+).
 */
(function () {
  "use strict";

  // The theme bundles jQuery through webpack and only sets `window.$`, not `window.jQuery`.
  var $ = window.jQuery || window.$;

  if (!$ || !$.fn) return;

  // ---------------------------------------------------------------------------
  // Title fallback: "Pot Elho Greenville golden sand" -> model "Elho Greenville",
  // colour "golden sand". Works by peeling colour words off from the END and
  // stopping at the first word that is not a colour.
  // ---------------------------------------------------------------------------
  // The product type belongs IN the grouping: a vase and a decorative pot with
  // the same model name (Elisa) are two different products and so each gets its
  // own tile with its own colour row. Titles without a type word
  // ("Fabien mystic green") fall back to 'pot' — that is the default case.
  var TYPE_WORDS = {
    pot: "pot",
    potten: "pot",
    sierpot: "pot",
    sierpotten: "pot",
    vaas: "vaas",
    vazen: "vaas",
    mand: "mand",
    manden: "mand",
    schaal: "schaal",
    schalen: "schaal",
    plantenbak: "plantenbak",
    plantenbakken: "plantenbak",
  };

  // Words that come before the model name but say nothing about the model.
  // "Pot Jumbo Patt Ivory Washed" is simply Patt in a larger size - the size is
  // already in the variants and in the pot opening filter, so here Jumbo is
  // noise that would split the model needlessly.
  var IGNORE_LEAD = { set: true, jumbo: true };
  var DEFAULT_TYPE = "pot";

  var COLOR_WORDS = [
    // NL
    "antraciet",
    "beige",
    "zwart",
    "wit",
    "zijdewit",
    "groen",
    "grijs",
    "geel",
    "goud",
    "gouden",
    "roze",
    "blauw",
    "bruin",
    "naturel",
    "cement",
    "mokka",
    "zilver",
    "rood",
    "oranje",
    "paars",
    "lila",
    "creme",
    "crème",
    "okergeel",
    "oker",
    "taupe",
    "terracotta",
    "terra",
    "roest",
    "zand",
    "linnen",
    "parel",
    "donkergroen",
    "lichtgroen",
    "donkergrijs",
    "lichtgrijs",
    "donkerblauw",
    "lichtblauw",
    "gebroken",
    "steen",
    "olijf",
    "olijfgroen",
    "mint",
    "zalm",
    // EN / brand names
    "anthracite",
    "charcoal",
    "black",
    "white",
    "ivory",
    "cream",
    "green",
    "grey",
    "gray",
    "yellow",
    "gold",
    "golden",
    "pink",
    "blue",
    "brown",
    "natural",
    "mocha",
    "silver",
    "red",
    "orange",
    "purple",
    "lavender",
    "amber",
    "olive",
    "rust",
    "sand",
    "stone",
    "clay",
    "coral",
    "denim",
    "khaki",
    "sage",
    "ocean",
    "forest",
    "ruby",
    "pearl",
    "camel",
    "latte",
    "rose",
    "blush",
    "nude",
    "sahara",
    "jade",
    "petrol",
    "aqua",
    "turquoise",
    "bordeaux",
    "plum",
    "peach",
    "apricot",
    "chocolate",
    "coffee",
    "espresso",
    "graphite",
    "grafiet",
    "platinum",
    "nickel",
    "nikkel",
    "titanium",
    "chrome",
    "chroom",
    "ivoor",
    "cognac",
    "cotta",
    "shell",
    "linen",
    "ash",
    "smoke",
    "earth",
    "copper",
    "bronze",
    "brass",
    "moss",
    "sky",
    // stone and metal names used as colours here
    "concrete",
    "laterite",
    "lead",
    "dioriet",
    "diorite",
    "tortora",
    "antra",
    "koper",
    "iron",
    "rusty",
    "caramel",
    "pine",
    "lilac",
    "tuscan",
    "rosy",
    "clouded",
    "royal",
    "transparant",
    "transparent",
    "licht",
    "donker",
    "marble",
    "marmer",
    // finishes that always belong to the colour
    "washed",
    "mystic",
    "vintage",
    "old",
    "matt",
    "matte",
    "gloss",
    "glans",
    "mat",
    "shiny",
    "metallic",
    "antique",
    "antiek",
  ];

  function inList(list, word) {
    for (var i = 0; i < list.length; i++) if (list[i] === word) return true;

    return false;
  }

  // Accents are removed for the comparison, so "Bronzé" and "Taupé" match just
  // as well as "bronze" and "taupe". The displayed colour name keeps the accent
  // - only the comparison is accent-free.
  function clean(token) {
    var t = String(token).toLowerCase();

    if (t.normalize) t = t.normalize("NFD").replace(/[̀-ͯ]/g, "");

    return t.replace(/[^\w-]/g, "");
  }

  function deriveFromTitle(title) {
    var tokens = String(title || "")
      .replace(/\s+/g, " ")
      .trim()
      .split(" ");

    if (!tokens.length) return { multiplier: "", category: DEFAULT_TYPE, model: "", color: "" };

    // 1. Read leading words: quantity ("2x", "6x") and product type ("Pot", "Vaas", "Mand").
    var start = 0;
    var multiplier = "";
    var category = "";

    while (start < tokens.length) {
      var lead = clean(tokens[start]);

      if (/^\d+x$/.test(lead)) {
        if (!multiplier) multiplier = lead;
        start++;
      } else if (TYPE_WORDS[lead]) {
        if (!category) category = TYPE_WORDS[lead];
        start++;
      } else if (IGNORE_LEAD[lead]) {
        start++;
      } else {
        break;
      }
    }

    var core = tokens.slice(start);

    if (!core.length) core = tokens.slice();

    // 2. Peel colour words off from the back, stop at the first non-colour word.
    var cut = core.length;

    while (cut > 1 && inList(COLOR_WORDS, clean(core[cut - 1]))) {
      cut--;
    }

    return {
      multiplier: multiplier,
      category: category || DEFAULT_TYPE,
      model: core.slice(0, cut).join(" "),
      color: core.slice(cut).join(" "),
    };
  }

  // Colour names come from the product title, and that is not consistent: "Pot
  // Lara Copper" but "Pot Elho Greenville golden sand". Under the cards it then
  // said "Copper" one time and "golden sand" the other. Capitalising every word
  // straightens that out - "Golden Sand" next to "Rose Gold".
  function hoofdletters(tekst) {
    return String(tekst || "").replace(/\S+/g, function (woord) {
      return woord.charAt(0).toUpperCase() + woord.slice(1);
    });
  }

  function modelKey(model) {
    return String(model || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function cardInfo($card) {
    var model = $.trim($card.attr("data-pot-model") || "");
    var color = $.trim($card.attr("data-pot-color") || "");

    var title =
      $card.attr("data-pot-title") || $card.find(".js-quickview-toggle").attr("data-title") || "";

    var derived = deriveFromTitle(title);
    var label;

    if (model) {
      // Metafield filled: that takes precedence. It already holds the product
      // type ("Vaas Elisa"), so no type is prepended again.
      label = model;
    } else {
      model = derived.model || title;
      label =
        (derived.multiplier ? derived.multiplier + " " : "") +
        derived.category.charAt(0).toUpperCase() +
        derived.category.slice(1) +
        " " +
        model;
    }

    if (!color) color = derived.color;
    label = $.trim(label) || title;

    return {
      model: model,
      label: label,
      color: hoofdletters(color || model),
      key: modelKey(label) || modelKey(title),
    };
  }

  // ---------------------------------------------------------------------------
  // Date split
  // ---------------------------------------------------------------------------
  // Some models exist twice in the catalogue: the original import and a later
  // batch from the supplier, with partly the same colours. Without stepping in
  // you then see two identical-looking colour dots side by side. As soon as a
  // colour appears twice within a model, we therefore split the model by
  // creation date into an old and a new series.
  //
  // The boundary comes from the duplicate colours themselves: the last "first
  // time" is the end of the old series, the first "second time" the start of
  // the new one. Everything in between goes to the series it is closest to by
  // date. Products without a creation date stay in the old series.
  function colorKeyOf(card) {
    return String(card.color || "")
      .trim()
      .toLowerCase();
  }

  function splitGroupByDate(group) {
    if (group.cards.length < 2) return null;

    var byColor = {};
    var i, c;

    for (i = 0; i < group.cards.length; i++) {
      c = colorKeyOf(group.cards[i]);
      (byColor[c] = byColor[c] || []).push(group.cards[i]);
    }

    var oldEnd = null;
    var newStart = null;

    for (var key in byColor) {
      if (!Object.prototype.hasOwnProperty.call(byColor, key)) continue;
      var list = byColor[key];

      if (list.length === 1) continue;

      // The same colour more than twice: too uncertain to split automatically.
      if (list.length > 2) return null;
      var a = list[0].created;
      var b = list[1].created;

      if (!a || !b || a === b) return null;
      var first = Math.min(a, b);
      var second = Math.max(a, b);
      oldEnd = oldEnd === null ? first : Math.max(oldEnd, first);
      newStart = newStart === null ? second : Math.min(newStart, second);
    }

    if (oldEnd === null || newStart === null || oldEnd >= newStart) return null;

    var oldCards = [];
    var newCards = [];

    for (i = 0; i < group.cards.length; i++) {
      var card = group.cards[i];
      var t = card.created;

      if (!t || t <= oldEnd) oldCards.push(card);
      else if (t >= newStart) newCards.push(card);
      else if (t - oldEnd <= newStart - t) oldCards.push(card);
      else newCards.push(card);
    }

    if (!oldCards.length || !newCards.length) return null;

    // Name of the new series: the year in which that series starts.
    var earliest = newCards[0].created;

    for (i = 1; i < newCards.length; i++) {
      if (newCards[i].created && newCards[i].created < earliest) earliest = newCards[i].created;
    }

    var year = new Date(earliest * 1000).getFullYear();

    return {
      oldCards: oldCards,
      newGroup: {
        key: group.key + "-" + year,
        model: group.model,
        label: group.label + " " + year,
        cards: newCards,
      },
    };
  }

  function splitDuplicateColorGroups() {
    var out = [];

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var split = splitGroupByDate(group);

      if (!split) {
        out.push(group);
        continue;
      }

      group.cards = split.oldCards;
      out.push(group);
      out.push(split.newGroup);
      byKey[split.newGroup.key] = split.newGroup;

      for (var n = 0; n < split.newGroup.cards.length; n++) {
        split.newGroup.cards[n].$el.attr("data-gb-model-key", split.newGroup.key);
      }
    }

    groups = out;
  }

  // ---------------------------------------------------------------------------
  // Construction
  // ---------------------------------------------------------------------------
  var QUICKVIEW_KEYS = [
    "title",
    "price",
    "pot-diameter",
    "pot-opening",
    "pot-material",
    "pot-height",
    "url",
    "image",
  ];

  var groups = [];
  var byKey = {};
  var $slider = null;
  var $colorPanel = null;
  var $geenPot = null;
  var built = false;

  function colorLabel() {
    return window.GB_POT_COLOR_LABEL || "Kleur";
  }

  // "4 kleuren" (4 colours) next to the heading. The theme has no translation
  // key for this, so the shop's eight languages are here; an unknown language
  // falls back to English.
  var KLEUREN_WOORDEN = {
    nl: "kleuren",
    de: "Farben",
    en: "colours",
    fr: "couleurs",
    da: "farver",
    es: "colores",
    pl: "kolory",
    sv: "färger",
  };

  // Without a pot you get the plant in its nursery pot. That is stated
  // nowhere, and then "geen pot" (no pot) looks like an incomplete choice instead
  // of a fine outcome. This line disappears as soon as a pot is chosen.
  var GEEN_POT = {
    nl: "Nog geen pot gekozen, je plant wordt geleverd in de kweekpot",
    de: "Noch kein Topf gewählt, deine Pflanze wird im Anzuchttopf geliefert",
    en: "No pot selected yet, your plant ships in its nursery pot",
    fr: "Aucun pot sélectionné, votre plante est livrée dans son pot de culture",
    da: "Ingen potte valgt endnu, din plante leveres i dyrkningspotten",
    es: "Aún no has elegido maceta, tu planta se envía en su maceta de cultivo",
    pl: "Nie wybrano jeszcze doniczki, roślina zostanie wysłana w doniczce hodowlanej",
    sv: "Ingen kruka vald ännu, din växt levereras i odlingskrukan",
  };

  var TAAL = (document.documentElement.getAttribute("lang") || "nl").slice(0, 2).toLowerCase();
  var KLEUREN_WOORD = KLEUREN_WOORDEN[TAAL] || KLEUREN_WOORDEN.en;
  var GEEN_POT_TEKST = GEEN_POT[TAAL] || GEEN_POT.en;

  // Colour names come from the product title and go into an attribute below.
  // A pot like "Grigio 12" Antique White" would otherwise break that attribute open.
  function esc(tekst) {
    return String(tekst == null ? "" : tekst)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function activeCard(group) {
    for (var i = 0; i < group.cards.length; i++) {
      if (group.cards[i].$el.find('input[name="addExtraPot"]').prop("checked"))
        return group.cards[i];
    }

    return group.cards[0];
  }

  // ---------------------------------------------------------------------------
  // Colour dots under the model tile
  // ---------------------------------------------------------------------------
  // Mini crops of the product photo instead of plain colour swatches. The
  // colours here are called Bronze, Copper, Mystic Earth, Beige Washed - those
  // are finishes, not flat colours, and Shopify holds no colour value anywhere.
  // So the photo is always right and costs no extra data.
  // How many fit side by side under a 140 pixel card depends on the size. Mini
  // photos are 26 pixels: four fit exactly, and when a "+N" has to go along too
  // (26 wide) three still fit - four minis plus a badge is 146 and runs over the
  // neighbouring card. Dots are 18 pixels, so five fit there, or four with a
  // badge after them (measured: 115 of the 140).
  // The counts above apply to the 140px card on desktop. On the phone the card
  // is 120px and the arithmetic no longer held: five buttons of 26px is 130px in
  // 116px of available space, so the row stuck out about 7px on both sides. On
  // the left the edge of the carousel cut off the first dot, on the right it
  // nearly touched the dots of the card next to it.
  //
  // Making them smaller was not possible: the button keeps min-width 26px for the
  // WCAG touch target of 24x24 (see layout/theme.liquid). So one fewer on mobile.
  // Four bare is 104px, three plus a badge is about 104px - both fit comfortably
  // in 116px.
  var GB_SMAL = !!(window.matchMedia && window.matchMedia("(max-width: 575.98px)").matches);

  var LIMIETEN = GB_SMAL
    ? {
        foto: { kaal: 3, metBadge: 2 },
        stip: { kaal: 4, metBadge: 3 },
      }
    : {
        foto: { kaal: 4, metBadge: 3 },
        stip: { kaal: 5, metBadge: 4 },
      };

  // The mini photos sit UNDER the card, not in it. They did not fit in the card:
  // between the price at the top and the bottom edge there is exactly enough
  // room for the pot photo itself, so anything you put in covers the pot - and
  // the "+" badge also sits at the bottom right. Outside the card the pot photo
  // is whole, the badge free and the row neatly centred. A small negative margin
  // lets them slide up against the bottom edge, so they visually belong to the
  // card.
  //
  // They are clickable though: a click picks that colour right away and unfolds
  // the colour row below. The visible dot is small, so the touch target is made
  // larger than what you see (see the ::after in the CSS) - otherwise you would
  // keep missing on a phone. The whole card also stays clickable and then picks
  // the colour that was already on.
  // ---------------------------------------------------------------------------
  // Which colour indicator? (A/B)
  // ---------------------------------------------------------------------------
  // Three ways to show that a model has more colours:
  //
  //   foto   mini crops of the product photo  (variant 2, current copy theme)
  //   stip   plain dots with the colour from that photo
  //   label  a text line "4 kleuren" (4 colours)
  //
  // Default 'foto'. A theme can switch that with window.GB_POT_SWATCH_STYLE, and
  // with ?gbpot=stip / ?gbpot=label / ?gbpot=foto you can switch manually in any
  // theme to see them side by side. That choice sticks within the tab, so you
  // can click on without dragging the parameter along.
  var STIJLEN = { foto: true, stip: true, label: true };

  function bepaalStijl() {
    var uit = null;

    try {
      var q = String(window.location.search || "").match(/[?&]gbpot=([a-z]+)/);

      if (q && STIJLEN[q[1]]) {
        uit = q[1];
        window.sessionStorage.setItem("gbPotStijl", uit);
      } else {
        var opgeslagen = window.sessionStorage.getItem("gbPotStijl");

        if (opgeslagen && STIJLEN[opgeslagen]) uit = opgeslagen;
      }
    } catch {
      // Private mode without sessionStorage: then just carry on without remembering.
    }

    if (!uit && STIJLEN[window.GB_POT_SWATCH_STYLE]) uit = window.GB_POT_SWATCH_STYLE;

    return uit || "foto";
  }

  var STIJL = bepaalStijl();

  // ---------------------------------------------------------------------------
  // Taking a pot's colour from its photo
  // ---------------------------------------------------------------------------
  // At first this took the average of all non-white pixels. That is honest but
  // looks wrong: the average also includes the dark inside at the opening and
  // the shadow under the pot, and those pull it grey. A golden pot turned olive
  // green that way.
  //
  // Now only the belly is measured - the band across the middle, without rim and
  // without shadow - and within it the middle range by brightness, so without the
  // deepest shadow side and without the white highlight.
  //
  // Then a correction goes over it. A small patch always looks duller than a
  // large area of the same colour, and the dot sits right under a photo five
  // times as large. A bit more saturation and lightness makes up for that. The
  // lightness is lifted along a sine: most in the middle of the scale, not at
  // near-black and near-white - otherwise a white pot becomes invisible and a
  // black pot grey.
  //
  // When reading fails (CORS, old device), the neutral background colour from
  // the CSS stays.
  // Precomputed colours. Without this, opening a page first showed a row of grey
  // dots: every pot photo had to be fetched and computed first. This table was
  // made with exactly the same recipe for all pots in the potting collections,
  // so the dot is right immediately. When a pot is not in it - a new pot, for
  // example - it falls back to the mini photo. So never a grey dot again.
  //
  // Updating is only needed when pots are added; the colour of an existing pot
  // does not change. The key is the product handle, with "pot-" shortened to
  // "~" to keep the file small.
  var KLEUREN_RUW =
    "designed-by-lammie-pot-bee-green e8e3bb|designed-by-lammie-pot-cotton-cream edd4b5|designed-by-lammie-pot-fiesta-fuchsia b68b98|" +
    "elho-vibes-fold-round-antraciet 5a5c62|elho-vibes-fold-round-groen b2b760|fabien-mystic-green 656651|" +
    "mand-ivo baa287|mand-jack c79b6c|opbergmand-scott e4b581|" +
    "mand-sofia ba8b61|~alto-natural-white e5dacd|~aniek-mokka 7f6b65|" +
    "~aro-wabi-beige d9d3c4|~athena e2dacd|~aurelia-gold-d25xh19 a5a05e|" +
    "~aurelia-vintage-green 7d8057|~babet-camel ddbb80|~bordo-new-egg-earth 565551|" +
    "~bordo-new-egg-grey bab8b5|~bordo-new-egg-sand e3e0dc|~bucket-beige-washed dcd8c2|" +
    "~bucket-black 383838|~bucket-grey 969696|carly-gold efdac7|" +
    "charlie-beige-washed dccfbf|~charlie-ivory-washed eae6e0|~christina-copper d8a083|" +
    "~cilia-latte bd7f54|~elho-amber-roll-beige e7dfd6|~elho-greenville-golden-sand d1c1a3|" +
    "~elho-greenville-groen 84916f|~elho-greenville-paars 8e698b|~elho-greenville-wit f0f0ef|" +
    "~elho-greenville-zwart 4d4d4d|~elho-sereh-rond-beige d8d4c6|~elho-vibes-fold-round-linnen-wit e0dbd2|" +
    "~elho-vibes-fold-round-groen c9d7cc|~elho-vibes-fold-round-roze ddb0a5|~elisa-mystic-bronze a8aea4|" +
    "~elisa-mystic-bronze-1 997b50|~elisa-mystic-earth 98a2af|~elisa-mystic-earth-1 697267|" +
    "elisa-mystic-green addedd|~elisa-vintage-green b79000|~elisa-vintage-green-1 707758|" +
    "~elsa-creme dfceb1|~elsa-groen b0bea4|~elsa-oranje e0ae7d|" +
    "~elsa-roze dda8a7|~fabien-old-camel bf7d27|~fleuri-high-travertine-beige eee4d8|" +
    "~fleuri-travertine-beige ebe3da|~fossil-bark-d10xh8 a0937e|~grigio-new-egg-antique-white ccc9bf|" +
    "~grigio-new-egg-antraciet 575a5d|~grigio-new-egg-natural-concrete 9d9991|~harith-high-travertine-beige ede4da|" +
    "~indigo-vintage-copper 574e52|indigo-pot-vintage-gold af9874|~jenna-gold ceb69f|" +
    "~jenna-gold-1 c8bf64|~jenna-lead a99b95|~jesslyn-black 313131|" +
    "~jolien-mystic-blue 746053|~lani-wabi-beige-d25-x-h22 d9d3c4|~lara-bronze-d29xh24 9b6c4a|" +
    "~lara-gold c4b867|~lara-rose-gold b7845f|~lauri-creme efdfc6|" +
    "~lauri-lichtgroen c6c6ac|~lauri-wit e7e5e2|~lauri-zwart 6d7856|" +
    "~lena-travertine-beige e4dacf|~lizzy-beige c4ad95|~lizzy-caramel c4a98f|" +
    "~lizzy-donkerbruin 725848|~madoka-wabi-beige dad5c9|~misa-wabi-beige dbd6c5|" +
    "designed-by-lammie-pot-monstera-mystery 9ca185|~mori-wabi-beige d1cbbd|~mountain-russel a49c92|" +
    "~nella-coffee 846b5b|~palermo-groen 3e6744|~palermo-marble-clay c1b4a4|" +
    "~palermo-wit dee2dd|~palermo-zwart 1e1e20|jumbo-patt-beige-washed e4dbd1|" +
    "jumbo-patt-black-washed 828188|~petra-wit f1f1f1|~petra-zwart 332f29|" +
    "~rens-tijm bebaa2|~sempre-vintage-gold a4855b|~stijn-goud ad8973|" +
    "~stijn-goud-1 ba9a86|~stijn-zwart 2d2d2d|~stijn-zwart-1 2c2c2c|" +
    "~terreno-new-egg-ash-brown 807478|~terreno-new-egg-earth 4e4b4b|~terreno-new-egg-sand d4cfc7|" +
    "rowen-gold a67b4c|vaas-elisa-mystic-bronze 928871|vaas-lemon-fusion f1ebd9|" +
    "~bordo-balloon-grey b9b7b4|~bordo-balloon-black 555350|~bordo-balloon-beige-washed e2dfdb|" +
    "~bucket-laterite-grey 6f706b|~cascara-holly-green 44534b|charlie-black-washed 8d868c|" +
    "eggy-35cm 1e262c|~eggy-bronze 542101|~eggy-taupe a79f9a|" +
    "~eggy-wit f0f2f3|~elho-green-basics-cilinderterracotta fec5a4|~grigio-cube-antique-white dbd5ca|" +
    "~grigo-cube-antraciet 6a6e75|~grigio-cube-bronze-143045281 c19f8b|~grigo-cube-concrete a4a196|" +
    "~grigio-new-egg-bronze-143045237 c2ab9e|~jumbo-orb-beige-washed e3d9cc|~jumbo-patt-ivory-washed eeeae4|" +
    "~kyra-terra ddbca2|~orb-grey-washed cbbcac|~orb-ivory-washed f4f0ea|" +
    "~ruvido-clay c4c3bf|~ruvido-earth 5a5a5a|~ruvido-sand ece8e3|" +
    "~terreno-new-egg-clay abaaa2";

  var KLEUREN = (function () {
    var uit = {},
      delen = KLEUREN_RUW.split("|");

    for (var i = 0; i < delen.length; i++) {
      var d = delen[i].split(" ");

      if (d.length === 2) uit[d[0]] = "#" + d[1];
    }

    return uit;
  })();

  function bekendeKleur(handle) {
    if (!handle) return null;

    return KLEUREN[String(handle).replace(/^pot-/, "~")] || KLEUREN[handle] || null;
  }

  // When a pot is not in the table - just added, for example - its colour is
  // still taken from the photo. The dot is then briefly invisible instead of
  // grey or a mismatched mini photo: rather a fraction later than wrong.
  function berekenKleur(src, klaar) {
    if (!src) return;
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () {
      try {
        var c = document.createElement("canvas");

        var W = (c.width = img.naturalWidth),
          H = (c.height = img.naturalHeight);

        var ctx = c.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var d = ctx.getImageData(0, 0, W, H).data;

        var mnX = W,
          mnY = H,
          mxX = 0,
          mxY = 0,
          x,
          y,
          i,
          lum;

        for (y = 0; y < H; y++)
          for (x = 0; x < W; x++) {
            i = (y * W + x) * 4;

            if (d[i + 3] < 40) continue;
            lum = (d[i] + d[i + 1] + d[i + 2]) / 3;

            if (lum > 236) continue;

            if (x < mnX) mnX = x;

            if (x > mxX) mxX = x;

            if (y < mnY) mnY = y;

            if (y > mxY) mxY = y;
          }

        if (mxX <= mnX || mxY <= mnY) return;

        var bw = mxX - mnX,
          bh = mxY - mnY;

        var y0 = Math.round(mnY + bh * 0.45),
          y1 = Math.round(mnY + bh * 0.85);

        var x0 = Math.round(mnX + bw * 0.2),
          x1 = Math.round(mnX + bw * 0.8);

        var band = [];

        for (y = y0; y <= y1; y++)
          for (x = x0; x <= x1; x++) {
            i = (y * W + x) * 4;

            if (d[i + 3] < 40) continue;
            lum = (d[i] + d[i + 1] + d[i + 2]) / 3;

            if (lum > 246) continue;
            band.push([d[i], d[i + 1], d[i + 2], lum]);
          }

        if (!band.length) return;
        band.sort(function (a, b) {
          return a[3] - b[3];
        });
        var van = Math.floor(band.length * 0.7);
        var tot = Math.max(Math.floor(band.length * 0.9), van + 1);

        var r = 0,
          g = 0,
          b = 0,
          n = 0;

        for (i = van; i < tot && i < band.length; i++) {
          r += band[i][0];
          g += band[i][1];
          b += band[i][2];
          n++;
        }

        if (!n) return;
        var h = naarHsl(r / n, g / n, b / n);
        klaar(
          naarHex(
            h[0],
            Math.min(1, h[1] * 1.25),
            Math.min(0.95, h[2] + 0.11 * Math.sin(Math.PI * h[2])),
          ),
        );
      } catch {
        // Photo without a CORS header: then the dot stays away.
      }
    };

    // 32 px instead of 120. This image is never shown: it only goes through the
    // canvas to determine the average colour for the dot. At 32 px that is still
    // well over a thousand pixels, more than enough for the percentile band above
    // — and it saves about 2 KB per pot model.
    img.src = src.split("?")[0] + "?width=32";
  }

  function naarHsl(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;

    var mx = Math.max(r, g, b),
      mn = Math.min(r, g, b),
      h = 0,
      s = 0,
      l = (mx + mn) / 2;

    if (mx !== mn) {
      var d = mx - mn;
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);

      if (mx === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }

    return [h, s, l];
  }

  function naarHex(h, s, l) {
    var r, g, b;

    if (s === 0) {
      r = g = b = l;
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s,
        p = 2 * l - q;

      var f = function (t) {
        if (t < 0) t += 1;

        if (t > 1) t -= 1;

        if (t < 1 / 6) return p + (q - p) * 6 * t;

        if (t < 1 / 2) return q;

        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;

        return p;
      };

      r = f(h + 1 / 3);
      g = f(h);
      b = f(h - 1 / 3);
    }

    return (
      "#" +
      [r, g, b]
        .map(function (v) {
          return ("0" + Math.round(v * 255).toString(16)).slice(-2);
        })
        .join("")
    );
  }

  // The table above was made by measuring the belly per pot photo - the band
  // across the middle, without rim and without shadow - taking the middle range
  // by brightness within it, and lifting the result a little in saturation and
  // lightness. The latter because an 18 pixel patch always looks duller than the
  // photo next to it. When pots are added, that calculation should run again;
  // the shop itself no longer computes anything.

  function buildSwatches(group) {
    if (group.cards.length < 2) return;

    var $row = $('<div class="gb-pot-model__swatches"></div>');
    $row.attr("data-stijl", STIJL);

    // Variant 3b: no images, just say what there is. Pure text, so nothing to
    // click - the card itself opens the colour row.
    if (STIJL === "label") {
      $row.attr("aria-hidden", "true");
      $row.append('<span class="gb-pot-model__count">' + group.cards.length + " kleuren</span>");
      group.$tile.append($row);

      return;
    }

    var limiet = LIMIETEN[STIJL] || LIMIETEN.foto;
    var shown = group.cards.length <= limiet.kaal ? group.cards.length : limiet.metBadge;

    for (var i = 0; i < shown; i++) {
      var card = group.cards[i];
      var src = card.$el.find(".related-pots__label img").first().attr("src") || "";
      var naam = card.color || "";

      // A button and not a span: it is a control, so it should work with tab and
      // enter, and a screen reader has to know what it picks.
      // The button itself is a transparent, larger touch target; the coloured patch
      // inside it is what you see. That helps: the patch has to clip its content
      // (overflow), and that would clip a larger touch target away again.
      var open =
        '<button type="button" class="gb-pot-swatch' +
        (STIJL === "stip" ? " gb-pot-swatch--dot" : "") +
        '" data-swatch-index="' +
        i +
        '" title="' +
        esc(naam) +
        '" aria-label="' +
        esc(naam) +
        '">';

      if (STIJL === "stip") {
        var vast = bekendeKleur(card.$el.attr("data-pot-handle"));

        if (vast) {
          // Colour already known: right immediately, no intermediate state at all.
          $row.append(
            open +
              '<span class="gb-pot-swatch__vlak" style="background-color:' +
              vast +
              '"></span></button>',
          );
        } else {
          // Still unknown: show the dot invisible and take the colour from the photo.
          var $wacht = $(open + '<span class="gb-pot-swatch__vlak"></span></button>');
          $wacht.addClass("gb-pot-swatch--wacht");
          $row.append($wacht);
          (function ($el) {
            berekenKleur(src, function (hex) {
              $el.find(".gb-pot-swatch__vlak").css("background-color", hex);
              $el.removeClass("gb-pot-swatch--wacht");
            });
          })($wacht);
        }
      } else {
        $row.append(
          open +
            '<span class="gb-pot-swatch__vlak"><img src="' +
            src +
            '" alt="" loading="lazy"></span>' +
            "</button>",
        );
      }
    }

    if (group.cards.length > shown) {
      $row.append(
        '<span class="gb-pot-model__more" aria-hidden="true">+' +
          (group.cards.length - shown) +
          "</span>",
      );
    }

    // Next to the label, not inside it: that way the pot photo stays fully visible.
    group.$tile.append($row);
  }

  function syncSwatches(group) {
    if (!group.$tile) return;
    var $swatches = group.$tile.find(".gb-pot-swatch");

    if (!$swatches.length) return;
    $swatches.each(function () {
      var i = parseInt($(this).attr("data-swatch-index"), 10);
      var card = group.cards[i];
      var on = !!(card && card.$el.find('input[name="addExtraPot"]').prop("checked"));
      $(this).toggleClass("is-active", on);
    });
  }

  function syncTile(group) {
    var card = activeCard(group);

    if (!card) return;
    var $tile = group.$tile;

    $tile.find(".related-pots__price").html(card.$el.find(".related-pots__price").html() || "");

    var $src = card.$el.find(".related-pots__label img").first();
    var $img = $tile.find(".related-pots__label img").first();
    $img.attr("src", $src.attr("src") || "");
    $img.attr("srcset", $src.attr("srcset") || "");
    $img.attr("sizes", $src.attr("sizes") || "");
    $img.attr("alt", $src.attr("alt") || "");

    // Take width/height from the source, so the aspect ratio matches the photo
    // that is actually shown and nothing jumps while loading.
    if ($src.attr("width")) $img.attr("width", $src.attr("width"));

    if ($src.attr("height")) $img.attr("height", $src.attr("height"));

    // Point the model tile's magnifier at the active colour.
    var $from = card.$el.find(".js-quickview-toggle").first();
    var $to = $tile.find(".js-quickview-toggle").first();

    for (var i = 0; i < QUICKVIEW_KEYS.length; i++) {
      var k = QUICKVIEW_KEYS[i];
      var v = $from.attr("data-" + k);
      $to.attr("data-" + k, v == null ? "" : v);
      $to.data(k, v == null ? "" : v); // keep the jQuery cache in sync
    }
  }

  function syncFromSelection() {
    var activeKey = null;
    var activeColor = "";

    var $checked = $('input[name="addExtraPot"]:checked')
      .filter(function () {
        return !!$(this).val();
      })
      .first();

    if ($checked.length) {
      var $card = $checked.closest(".related-pots");
      var key = $card.attr("data-gb-model-key");

      if (key && byKey[key]) {
        activeKey = key;

        for (var i = 0; i < byKey[key].cards.length; i++) {
          if (byKey[key].cards[i].$el.is($card)) activeColor = byKey[key].cards[i].color;
        }
      }
    }

    var showPanel = false;

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var on = group.key === activeKey;
      group.$tile.toggleClass("is-active", on);
      group.$tile.find('input[name="gbPotModel"]').prop("checked", on);
      group.$group.css("display", on ? "contents" : "none");

      if (on && group.cards.length > 1) showPanel = true;
      syncTile(group);
      syncSwatches(group);
    }

    if ($geenPot) $geenPot.toggle(!activeKey);

    var wasZichtbaar = $colorPanel.is(":visible");
    $colorPanel.toggle(showPanel);
    $colorPanel.find(".js-gb-color-name").text(showPanel ? activeColor : "");

    var aantal = showPanel && byKey[activeKey] ? byKey[activeKey].cards.length : 0;
    $colorPanel.find(".js-gb-color-count").text(aantal ? aantal + " " + KLEUREN_WOORD : "");

    if (showPanel) {
      $colorPanel.addClass("is-open");

      // Only draw attention on OPENING, not on every colour change after that -
      // otherwise the screen jumps away under your hands while you are choosing.
      if (!wasZichtbaar) {
        $colorPanel.removeClass("gb-pot-colors--nieuw");
        // force a reflow so the animation restarts
        void $colorPanel[0].offsetWidth;
        $colorPanel.addClass("gb-pot-colors--nieuw");
        brengInBeeld();
      }
    } else {
      $colorPanel.removeClass("is-open gb-pot-colors--nieuw");
    }
  }

  // On mobile the colour row easily sits below the fold. When it is not fully in
  // view, we scroll it there calmly. Not on desktop: there everything already
  // sits side by side and scrolling would only disturb.
  function brengInBeeld() {
    if (window.innerWidth >= 992) return;
    var el = $colorPanel[0];

    if (!el) return;
    window.setTimeout(function () {
      var r = el.getBoundingClientRect();
      var onder = window.innerHeight - 90; // room for the fixed bar at the bottom

      if (r.bottom <= onder && r.top >= 60) return;

      // scrollIntoView and not window.scrollTo: this theme does not scroll the page
      // through the window but through an element around it, so scrollTo on window
      // does nothing here.
      if (el.scrollIntoView) {
        try {
          el.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        } catch {
          el.scrollIntoView();
        }
      }
    }, 60);
  }

  function build() {
    if (built) return;
    $slider = $(".js-oppot-slider").first();

    if (!$slider.length) return;

    var $cards = $slider.children(".related-pots").not(".related-pots--view-all");

    if ($cards.length < 2) return;
    built = true;

    // 1. Group in the order the theme already determined (collection, then price).
    $cards.each(function () {
      var $card = $(this);
      var info = cardInfo($card);
      $card.attr("data-gb-model-key", info.key);
      var group = byKey[info.key];

      if (!group) {
        group = byKey[info.key] = {
          key: info.key,
          model: info.model,
          label: info.label,
          cards: [],
        };
        groups.push(group);
      }

      group.cards.push({
        $el: $card,
        color: info.color,
        created: parseInt($card.attr("data-pot-created"), 10) || 0,
      });
    });

    splitDuplicateColorGroups();

    // 2. Hang the colour panel under the strip.
    $colorPanel = $(
      '<div class="gb-pot-colors" style="display:none">' +
        '<div class="gb-pot-colors__heading">' +
        '<strong class="fw-semibold lh-1">' +
        colorLabel() +
        "</strong>" +
        '<span class="gb-pot-colors__value js-gb-color-name"></span>' +
        '<span class="gb-pot-colors__aantal js-gb-color-count"></span>' +
        "</div>" +
        '<div class="gb-pot-colors__row"></div>' +
        "</div>",
    );
    $slider.closest(".oppot-slider").after($colorPanel);
    $geenPot = $('<p class="gb-pot-geen"></p>').text(GEEN_POT_TEKST);
    $slider.closest(".oppot-slider").after($geenPot);
    var $row = $colorPanel.find(".gb-pot-colors__row");

    // 3. Per model: fill the colour group and build a model tile.
    var $tiles = $();

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];

      // Note: display is set explicitly here and jQuery .hide()/.show()/.toggle()
      // is deliberately NOT used. In the CSS this wrapper is display:contents, so
      // the colour cards themselves are the flex items of the row. On .hide() jQuery
      // remembers what the "normal" display of a div is and on .show() sets
      // display:block back - and that overrides display:contents. The wrapper then
      // became a flex item itself with the cards beneath it, exactly the picture in
      // which the pots end up stacked.
      group.$group = $(
        '<div class="gb-pot-colors__group" data-model-key="' + group.key + '"></div>',
      ).css("display", "none");

      for (var c = 0; c < group.cards.length; c++) {
        var $kaart = group.cards[c].$el.show().addClass("gb-pot-color-card");

        // Colour name under the card: makes the choice readable and the touch target larger.
        if (group.cards[c].color && !$kaart.find(".gb-pot-color-card__name").length) {
          $kaart.append(
            $('<span class="gb-pot-color-card__name"></span>').text(group.cards[c].color),
          );
        }

        $kaart.appendTo(group.$group);
      }

      $row.append(group.$group);

      var inputId = "gb-pot-model-" + i;
      group.$tile = $(
        '<div class="related-pots gb-pot-model rounded-2 position-relative pb-1" data-model-key="' +
          group.key +
          '">' +
          '<input class="related-pots__input" type="radio" name="gbPotModel" id="' +
          inputId +
          '" value="' +
          group.key +
          '">' +
          '<label class="related-pots__label js-gb-select-model" for="' +
          inputId +
          '">' +
          '<span class="related-pots__price"></span>' +
          // loading="lazy" was missing here. The Liquid variant cards have it, but
          // this tile is built by JS and did not inherit it — so all 31 model photos
          // came in right away while the pot block sits below the fold. syncTile takes
          // width/height over from the source image; the 600x600 that was here did not
          // fit pot photos that are, for example, 600x545.
          '<img class="img-abs-center" alt="" loading="lazy">' +
          "</label>" +
          '<div class="related-pots__view js-quickview-toggle" data-bs-toggle="modal" data-bs-target="#exampleModal">' +
          '<i class="fa-sharp fa-solid fa-magnifying-glass"></i>' +
          "</div>" +
          "</div>",
      );
      group.$tile.attr("title", group.label);
      buildSwatches(group);
      $tiles = $tiles.add(group.$tile);
    }

    // 4. Put the model tiles in the strip, "alle potten bekijken" (view all pots) after the first three.
    var $viewAll = $slider.children(".related-pots--view-all").detach();
    $slider.append($tiles);

    // All models are in the strip right away, on every screen size. The "Alle
    // potten bekijken" (view all pots) button therefore goes away: thanks to the
    // colour grouping the row is short enough to simply scroll through, and an
    // extra click between the customer and the rest of the range costs more than
    // it yields. This is exactly the state you used to get after clicking that
    // button.
    var $placed = $slider.children(".gb-pot-model");
    $placed.show();
    $viewAll.remove();
    $slider.addClass("is-scrollable").css("overflow-x", "scroll");
    $slider.closest(".oppot-slider-wrapper").find(".oppot-scrollbar-track").css("display", "block");

    syncFromSelection();
    $slider.css("visibility", "visible");
  }

  // ---------------------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------------------

  // Click on a model tile -> select the active colour of that model.
  // When the model is already on, PotFinder does its own toggle (= deselect),
  // exactly like with a regular pot card.
  $(document).on("click", ".gb-pot-model .js-gb-select-model", function (e) {
    e.preventDefault();
    var key = $(this).closest(".gb-pot-model").attr("data-model-key");
    var group = byKey[key];

    if (!group) return;
    var card = activeCard(group);

    if (!card) return;
    card.$el.find(".js-select-pot").first().trigger("click");
    window.setTimeout(syncFromSelection, 0);
  });

  // Click on a colour dot / mini photo -> pick that colour right away. The row
  // sits outside the label, so this does not clash with the click on the card
  // itself; the stopPropagation is there in case the markup ever changes.
  $(document).on("click", ".gb-pot-model .gb-pot-swatch", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $sw = $(this);
    var group = byKey[$sw.closest(".gb-pot-model").attr("data-model-key")];

    if (!group) return;
    var card = group.cards[parseInt($sw.attr("data-swatch-index"), 10)];

    if (!card) return;
    // When this colour is already on, PotFinder does its own toggle and the pot
    // is released - the same behaviour as a second click on the card.
    card.$el.find(".js-select-pot").first().trigger("click");
    window.setTimeout(syncFromSelection, 0);
  });

  // Click on a colour card -> PotFinder handles the selection, we update the tile.
  $(document).on("click", ".gb-pot-color-card .js-select-pot", function () {
    window.setTimeout(syncFromSelection, 0);
  });

  // Safety net: any other change of the pot selection (e.g. a reset on a size change).
  $(document).on("change", 'input[name="addExtraPot"]', function () {
    if (built) window.setTimeout(syncFromSelection, 0);
  });

  // ---------------------------------------------------------------------------
  // Wait until initOppotConfigurator is done. It sets visibility to visible as
  // its last step, so that is the start signal. A generous timeout as a safety
  // net.
  // ---------------------------------------------------------------------------
  function waitForConfigurator() {
    var tries = 0;

    var timer = window.setInterval(function () {
      tries++;
      var slider = document.querySelector(".js-oppot-slider");

      if (!slider) {
        if (tries > 100) window.clearInterval(timer);

        return;
      }

      var ready =
        slider.style.visibility === "visible" &&
        slider.querySelectorAll(".related-pots").length > 0;

      if (ready || tries > 250) {
        window.clearInterval(timer);

        if (slider.querySelectorAll(".related-pots").length > 0) build();
      }
    }, 60);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForConfigurator);
  } else {
    waitForConfigurator();
  }
})();
